export const tagsApi = {
  tags: {
    queryKey: (params?: string[]) => ["tags", ...(params || [])],
    route: () => `tags`,
    methods: ["GET", "POST"],
  },
  tag: {
    queryKey: (id: number, params?: string[]) => [
      "tags",
      id,
      ...(params || []),
    ],
    route: (id: number) => `tags/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
